import Button from "components/Button/Button";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import filterCourses from "service/courses/filter-courses";
import "./filterDropdown.scss";

function FilterDropdown({ toggler, togglerText, onApply, onClear }) {
  const [levels, setLevels] = useState([]);
  const queryClient = useQueryClient();
  useQuery(["levels"], filterCourses, {
    onSuccess: (lvls) => {
      const l = [];
      for (let i = 0; i < lvls.length; i++) {
        if (typeof lvls[i] === "string") {
          l.push(lvls[i]);
        }
      }

      setLevels(l);
    },
  });
  const { mutate } = useMutation(filterCourses, {
    onSuccess: () => queryClient.invalidateQueries(["levels"]),
  });

  return (
    <div className="cifHeader__filter_wrapper">
      <Dropdown>
        <Dropdown.Toggle as={toggler} id="dropdown-filter">
          {togglerText}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <div className="cifHeader__filter_header d-flex align-items-center justify-content-between ">
            <span className="fw-500 font-md">Filter</span>
            <hr />
            {/* <span
              onClick={() => mutate("-1")}
              className="fw-400 cif__text_primary font-md cursor-pointer"
            >
              Clear All
            </span> */}
          </div>
          <div className="cifHeader__filter_slider_wrapper mt-2">
            {/* <div className="font-md cif__text_primary fw-500">Grade</div>
            <div className="cifHeader__filter_range_wrapper mt-3 pb-3">
              <RangeSlider defaultValue={[10, 50]} />
            </div> */}
            <div className="cifHeader__filter_sill_wrapper">
              <span className="font-md fw-500">
                Please choose the appropriate skill level
              </span>
              <div className="mt-2 d-flex flex-column gap-1">
                {["Beginner", "Intermediate", "Advanced"].map((g, i) => (
                  <div key={i} className="d-flex align-items-center">
                    <input
                      className="cif__checkbox"
                      type="checkbox"
                      name="skill"
                      checked={levels.find((c) => c === g) ? true : false}
                      id={g}
                      onChange={() => mutate(g)}
                    />
                    <label className="font-md ms-2" htmlFor={g}>
                      {g}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            {/* <div className="filterDropdown__btn_wrapper text-end mt-3">
              <Button onClick={onApply} className="font-sm" rounded={true}>
                Apply
              </Button>
            </div> */}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default FilterDropdown;
